module.exports = __webpack_public_path__ + "img/vertical_1_1_7042.6b3f7e9b.png";